


















































import Vue from 'vue'
import Promote from '~/components/car/classifieds/promote/Promote.vue'
import { mapActions, mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import PromoteInfoTip from '~/components/car/classifieds/promote/PromoteInfoTip.vue'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import PromoteAdminButtons from '~/components/car/classifieds/promote/PromoteAdminButtons.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import CCardTitle from '~/components/shared/configurable/card/CCardTitle.vue'

export default Vue.extend({
  components: {
    CCardHeader,
    PromoteAdminButtons,
    CContextMenu,
    Promote,
    CCard,
    CCardTitle,
    PromoteInfoTip
  },
  props: {
    classified: { type: Object, required: true }
  },
  data() {
    return {
      showHelp: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    icons() {
      return {
        ellipsis: faEllipsisV
      }
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      reloadClassifiedView: 'reloadClassifiedView'
    }),
    banPromoClassified(closeFunction: Function) {
      closeFunction()
      this.$refs.promote.banPromoClassified()
    },
    banPromoUser(closeFunction: Function) {
      closeFunction()
      this.$refs.promote.banPromoUser()
    },
    enablePromoClassified(closeFunction: Function) {
      closeFunction()
      this.$refs.promote.enablePromoClassified()
    },
    enablePromoUser(closeFunction: Function) {
      closeFunction()
      this.$refs.promote.enablePromoUser()
    }
  }
})
